import { getAnalytics, initializeAnalytics, isSupported } from "firebase/analytics";
import app from "../../firebase/config";
import { isAnalyticsDebugEnabled } from "./analyticsEnvironment";

/**
 * GA4 DebugView on web: pass `debug_mode: true` in the initial gtag config.
 * The modular SDK does not read `globalThis.FIREBASE_ANALYTICS_DEBUG_MODE` (v10+).
 * @returns {import('firebase/analytics').AnalyticsSettings | undefined}
 */
export function firebaseAnalyticsInitSettings() {
  if (!isAnalyticsDebugEnabled()) return undefined;
  return {
    config: {
      debug_mode: true,
    },
  };
}

/**
 * First Analytics init for this Firebase app. When debug is opted in (dev only),
 * uses `initializeAnalytics` so collect URLs include the GA4 debug marker.
 * @param {import('@firebase/app').FirebaseApp} [firebaseApp]
 * @returns {Promise<import('firebase/analytics').Analytics | null>}
 */
export async function acquireFirebaseAnalytics(firebaseApp = app) {
  const supported = await isSupported();
  if (!supported) return null;

  const settings = firebaseAnalyticsInitSettings();
  if (settings) {
    return initializeAnalytics(firebaseApp, settings);
  }
  return getAnalytics(firebaseApp);
}
